import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useMemo } from 'react';
import { isString, __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import '../../hooks/use-safe-layout-effects.esm.js';
import '../../hooks/use-callback-ref.esm.js';
import '../../hooks/use-clickable.esm.js';
import { useClipboard } from '../../hooks/use-clipboard.esm.js';
import '../../hooks/use-combobox-dropdown-style.esm.js';
import '../../hooks/use-combobox-style.esm.js';
import '../../hooks/use-controllable.esm.js';
import '../../hooks/use-local-storage.esm.js';
import '../../hooks/use-media.esm.js';
import '../../hooks/use-prefers-dark-mode.esm.js';
import { useDarkMode } from '../../hooks/use-dark-mode.esm.js';
import '../../hooks/use-force-update.esm.js';
import '../../hooks/use-descendant.esm.js';
import '../../hooks/use-id.esm.js';
import '../../hooks/use-previous.esm.js';
import '../../hooks/use-disclosure.esm.js';
import '../../hooks/use-dropdown-style.esm.js';
import '../../hooks/use-latest-ref.esm.js';
import '../../hooks/use-event-listener.esm.js';
import '../../hooks/use-event-listener-v2.esm.js';
import '../../hooks/use-update-effect.esm.js';
import '../../hooks/use-focus-on-hide.esm.js';
import '../../hooks/use-pointer-event.esm.js';
import '../../hooks/use-focus-on-pointerdown.esm.js';
import '../../hooks/use-focus-on-show.esm.js';
import '../../hooks/use-fork-ref.esm.js';
import '../../hooks/use-hints.esm.js';
import '../../hooks/use-input-style.esm.js';
import '../../hooks/use-key-press.esm.js';
import '../../hooks/use-lock-body-scroll.esm.js';
import '../../hooks/use-platform.esm.js';
import '../../hooks/use-shortcut.esm.js';
import Highlight, { defaultProps } from 'prism-react-renderer';
import CodeCopyButton from './CodeCopyButton/index.esm.js';
export { default as CodeCopyButton } from './CodeCopyButton/index.esm.js';
import themes from './theme.esm.js';
export { default as codeThemes } from './theme.esm.js';

var Code = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      language = props.language,
      _props$showCopyButton = props.showCopyButton,
      showCopyButton = _props$showCopyButton === void 0 ? true : _props$showCopyButton,
      wrap = props.wrap,
      rest = _objectWithoutPropertiesLoose(props, ["value", "language", "showCopyButton", "wrap"]);

  var theme = props.theme;

  var _useDarkMode = useDarkMode(),
      darkMode = _useDarkMode[0]; // Auto select theme based


  if (!theme) {
    theme = darkMode ? 'dark' : 'light';
  } // Serialize with 2 space tabs if needed


  var code = useMemo(function () {
    return !isString(value) ? JSON.stringify(value, null, 2) : value;
  }, [value]);

  var _useClipboard = useClipboard(code),
      onCopy = _useClipboard.onCopy,
      hasCopied = _useClipboard.hasCopied;

  var wrapperProps = {
    borderRadius: 'rounded-lg',
    backgroundColor: theme === 'dark' ? 'bg-gray-900' : 'bg-white',
    borderWidth: 'border',
    borderColor: theme === 'dark' ? 'border-transparent' : 'border-gray-200'
  };
  var contentProps = {
    height: 'h-full',
    padding: 'p-4',
    overflow: 'overflow-auto',
    fontFamily: 'font-mono',
    fontSize: 'text-code',
    textColor: theme === 'dark' ? 'text-gray-200' : 'text-gray-700',
    whitespace: wrap ? 'whitespace-pre-wrap' : undefined,
    borderRadius: 'rounded-inherit'
  };
  return React__default.createElement(Box, _extends({
    position: "relative"
  }, wrapperProps, rest), showCopyButton && React__default.createElement(CodeCopyButton, {
    onClick: onCopy,
    theme: theme
  }, hasCopied ? 'Copied!' : 'Copy'), language && React__default.createElement(Highlight, _extends({
    ref: ref
  }, defaultProps, {
    theme: themes[theme],
    code: code,
    language: language
  }), function (_ref) {
    var className = _ref.className,
        style = _ref.style,
        tokens = _ref.tokens,
        getLineProps = _ref.getLineProps,
        getTokenProps = _ref.getTokenProps;
    return React__default.createElement(Box, _extends({
      as: "pre"
    }, contentProps, {
      dangerouslySetClassName: className,
      style: style
    }), tokens.map(function (line, i) {
      return React__default.createElement(Box, _extends({}, getLineProps({
        line: line,
        key: i
      })), line.map(function (token, key) {
        return React__default.createElement(Box, _extends({
          as: "span"
        }, getTokenProps({
          token: token,
          key: key
        })));
      }));
    }));
  }), !language && React__default.createElement(Box, _extends({
    as: "pre"
  }, contentProps), value));
});

if (__DEV__) {
  Code.displayName = 'Code';
}

export default Code;
//# sourceMappingURL=index.esm.js.map
